import { ApolloProvider } from "@apollo/client";
import type { FC, ReactNode } from "react";

import { useClient } from "./useClient";

interface Props {
  children: ReactNode;
}

const ApolloClientProvider: FC<Props> = ({ children }) => {
  const client = useClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export { ApolloClientProvider };
